import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/a_4.svg")